import React, { useState } from 'react';
import { makeStyles } from '@mui/styles';
import { TableHead, TableRow, TableCell, IconButton } from '@mui/material';
import { KeyboardArrowRight, KeyboardArrowDown } from '@mui/icons-material';
import { NUTRIENT_TABLE_CONSTANTS } from '../utils/nutrientTableConstants';

const { DESKTOP_COLUMN_WIDTHS } = NUTRIENT_TABLE_CONSTANTS;

const useStyles = makeStyles((theme) => ({
  tableHead: {
    ...theme.globalClasses.adminTableHead,
    marginLeft: '10px',
    '& .MuiTableRow-root': {
      borderBottom: `1px solid ${theme.palette.divider}`,
    },
  },
  tableTitleCell: {
    textAlign: 'left',
    height: '56px',
    display: 'flex',
    alignItems: 'center',
    width: DESKTOP_COLUMN_WIDTHS.nutrient.width,
    minWidth: DESKTOP_COLUMN_WIDTHS.nutrient.minWidth,
    padding: DESKTOP_COLUMN_WIDTHS.nutrient.padding,
  },
  mobileTableTitleCell: {
    height: '56px',
    textAlign: 'center',
    width: '33.33%',
  },
  cellContent: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
  },
  cellContentCentered: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '56px',
  },
  currentCell: {
    width: DESKTOP_COLUMN_WIDTHS.current.width,
    minWidth: DESKTOP_COLUMN_WIDTHS.current.minWidth,
    padding: DESKTOP_COLUMN_WIDTHS.current.padding,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  goalCell: {
    width: DESKTOP_COLUMN_WIDTHS.goal.width,
    minWidth: DESKTOP_COLUMN_WIDTHS.goal.minWidth,
    padding: DESKTOP_COLUMN_WIDTHS.goal.padding,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  changeCell: {
    width: DESKTOP_COLUMN_WIDTHS.change.width,
    minWidth: DESKTOP_COLUMN_WIDTHS.change.minWidth,
    padding: DESKTOP_COLUMN_WIDTHS.change.padding,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  sliderCell: {
    width: DESKTOP_COLUMN_WIDTHS.slider.width,
    minWidth: DESKTOP_COLUMN_WIDTHS.slider.minWidth,
    padding: DESKTOP_COLUMN_WIDTHS.slider.padding,
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontSize: '18.72px',
    fontWeight: 700,
    lineHeight: '116.7%',
    textTransform: 'capitalize',
    color: theme.palette.black87,
    display: 'flex',
    alignItems: 'center',
  },
}));

const NutrientTableHeader = ({ variant = 'desktop', type, onExpandChange }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
    onExpandChange?.(!expanded);
  };

  if (variant === 'mobile') {
    return (
      <TableHead className={classes.tableHead}>
        <TableRow>
          <TableCell>Current</TableCell>
          <TableCell className={classes.mobileTableTitleCell}>Goal</TableCell>
          <TableCell className={classes.mobileTableTitleCell}>Change</TableCell>
        </TableRow>
      </TableHead>
    );
  }

  return (
    <TableHead className={classes.tableHead}>
      <TableRow style={{ display: 'flex', width: '806px' }}>
        <TableCell className={classes.tableTitleCell}>
          <IconButton
            onClick={handleExpandClick}
            size="medium"
          >
            {expanded ? (
              <KeyboardArrowDown sx={{ height: '32px', width: '32px' }} />
            ) : (
              <KeyboardArrowRight sx={{ height: '32px', width: '32px' }} />
            )}
          </IconButton>
          <span className={classes.title}>{type}</span>
        </TableCell>
        {expanded && (
          <>
            <TableCell className={classes.currentCell}>Current</TableCell>
            <TableCell className={classes.goalCell}>Goal</TableCell>
            <TableCell className={classes.changeCell}>Change</TableCell>
            <TableCell className={classes.sliderCell} />
          </>
        )}
      </TableRow>
    </TableHead>
  );
};

export default NutrientTableHeader;
